import { render, staticRenderFns } from "./mo-focus-on-org.vue?vue&type=template&id=020235b9&scoped=true&"
import script from "./mo-focus-on-org.vue?vue&type=script&lang=js&"
export * from "./mo-focus-on-org.vue?vue&type=script&lang=js&"
import style0 from "./mo-focus-on-org.vue?vue&type=style&index=0&id=020235b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020235b9",
  null
  
)

export default component.exports